import React from 'react';
import parse from 'html-react-parser';
import { PostContentFromAdminPanelStyles } from './PostContentFromAdminPanelStyles';

function PostContentFromAdminPanel({ content }: {content: string}) {
  return (
    <PostContentFromAdminPanelStyles className="postContent">
      {parse(content)}
    </PostContentFromAdminPanelStyles>
  );
}

export default PostContentFromAdminPanel;
